import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import baterai from '../images/seagull-baterai.jpg';
import airbagg from '../images/seagull-airbag.jpg';
import kaki from '../images/seagull-kaki.jpg';
import rangka from '../images/seagull-rangka.jpg';
import charging from '../images/seagull-charging.jpg';
import fitur from '../images/seagull-fitur.jpg';

function FiturSeagull() {
  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <Helmet>
        <title>
          Fitur Keamanan & Teknologi BYD Atto1 - Mobil Listrik Canggih di BYD
          BSD Serpong
        </title>
        <meta
          name='description'
          content='Intip fitur-fitur keamanan, teknologi, dan performa BYD Atto1 lengkap. Termasuk airbag, baterai Blade, sistem pengisian cepat, rangka kuat, dan fitur pintar NFC. Tersedia di BYD BSD Serpong.'
        />
        <meta
          name='keywords'
          content='BYD Atto1, Fitur Atto1, BYD BSD Serpong, Harga Denza D9, Harga Sealion 7, Harga v'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/fitur-byd-Atto1'
        />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        Fitur Canggih & Teknologi Keamanan BYD Atto1 2025
      </Typography>

      <Typography
        variant='body1'
        paragraph
        sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
      >
        BYD Atto1 hadir sebagai mobil listrik masa depan yang tak hanya
        menarik dari sisi desain, tapi juga dilengkapi berbagai fitur keamanan
        dan teknologi terkini. Di dealer <strong>BYD BSD Serpong</strong>, kamu
        bisa menemukan Atto1 dengan spesifikasi lengkap, dari sistem
        keselamatan aktif hingga inovasi baterai <em>Blade</em> Battery yang
        telah diakui dunia. Dalam artikel ini, kita akan bahas semua fitur
        unggulan BYD Atto1 untuk memastikan kamu mendapatkan gambaran jelas
        sebelum membeli mobil listrik impian ini.
      </Typography>

      {/* Airbag Section */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Keamanan Maksimal: 6 Airbag dan Sistem Proteksi Lengkap
        </Typography>
        <img
          src={airbagg}
          alt='Airbag BYD Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Keamanan adalah prioritas utama di BYD Atto1. Mobil ini dilengkapi
          dengan 6 airbag yang tersebar di depan, samping, dan curtain untuk
          memberikan perlindungan menyeluruh bagi pengemudi dan penumpang. Tak
          hanya itu, struktur bodi mobil telah dirancang agar menyerap benturan
          secara efektif dalam situasi tabrakan.
        </Typography>
      </Box>

      {/* Blade Battery */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Blade Battery: Teknologi Baterai Teraman di Dunia
        </Typography>
        <img
          src={baterai}
          alt='Baterai Blade BYD Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Salah satu fitur paling revolusioner di BYD Atto1 adalah penggunaan
          Blade Battery—baterai LFP (Lithium Iron Phosphate) yang tahan panas
          dan tahan benturan. Blade Battery telah lolos uji penetrasi paku dan
          digunakan juga di model seperti BYD Denza D9 dan BYD Sealion 7.
          Teknologi ini menjamin keamanan dan daya tahan tinggi, sekaligus
          memberikan jarak tempuh optimal.
        </Typography>
      </Box>

      {/* Fast Charging */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Pengisian Cepat: 30 Menit Sampai 80%
        </Typography>
        <img
          src={charging}
          alt='Charging Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Dengan sistem fast charging DC, kamu bisa mengisi daya hingga 80%
          hanya dalam waktu 30 menit. Fitur ini sangat membantu dalam mobilitas
          harian, terutama di kota besar seperti Jakarta dan BSD Serpong. Soket
          charging berada di samping bodi, mudah dijangkau dan kompatibel dengan
          standar pengisian publik di Indonesia.
        </Typography>
      </Box>

      {/* Suspensi dan Kaki-kaki */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Kaki-kaki Stabil dan Empuk untuk Kenyamanan Kota
        </Typography>
        <img
          src={kaki}
          alt='Kaki-kaki BYD Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Suspensi MacPherson di bagian depan dan torsion beam di belakang
          membuat BYD Atto1 sangat nyaman dikendarai di jalanan kota.
          Stabilitas tinggi, handling responsif, dan redaman yang pas memberikan
          pengalaman berkendara yang memuaskan bahkan di jalan berlubang
          sekalipun.
        </Typography>
      </Box>

      {/* Rangka Baja */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Rangka Baja Ultra High-Strength: Tangguh & Ringan
        </Typography>
        <img
          src={rangka}
          alt='Rangka BYD Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Atto1 menggunakan rangka baja berkekuatan tinggi (ultra
          high-strength steel) untuk menjaga keseimbangan antara ringan dan
          kuat. Ini membuat konsumsi energi lebih efisien sekaligus memperkuat
          daya tahan struktur terhadap benturan.
        </Typography>
      </Box>

      {/* Fitur Pintar NFC */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Buka Mobil Pakai Smartphone? Bisa Banget!
        </Typography>
        <img
          src={fitur}
          alt='Fitur NFC Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Fitur NFC (Near Field Communication) memungkinkan kamu membuka dan
          menghidupkan mobil hanya dengan mendekatkan smartphone ke spion. Ini
          bukan hanya futuristik, tapi juga sangat praktis untuk mobilitas
          sehari-hari di perkotaan.
        </Typography>
      </Box>

      {/* Kesimpulan dan CTA */}
      <Paper
        sx={{
          p: 4,
          mt: 6,
          backgroundColor: '#e3f2fd',
          borderLeft: '6px solid #1976d2',
          borderRadius: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          🚗 Siap Punya Mobil Listrik Seaman & Secanggih Ini?
        </Typography>
        <Typography variant='body1'>
          Semua fitur ini bisa kamu dapatkan langsung di{' '}
          <strong>BYD BSD Serpong</strong>. Dapatkan juga info lengkap seputar{' '}
          <strong>Harga Denza D9</strong>, <strong>Harga Sealion 7</strong>, dan{' '}
          <strong>Harga Atto1</strong> dengan menghubungi tim kami.
        </Typography>
        <Typography variant='body2' sx={{ mt: 1 }}>
          📞{' '}
          <a
            href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20dengan%20fitur%20BYD%20Seagull'
            target='_blank'
            rel='noopener noreferrer'
          >
            Chat WhatsApp
          </a>{' '}
          atau kunjungi Instagram kami di{' '}
          <a
            href='https://instagram.com/bydbsdserpong'
            target='_blank'
            rel='noopener noreferrer'
          >
            @bydbsdserpong
          </a>
          !
        </Typography>
      </Paper>
    </Box>
  );
}

export default FiturSeagull;
